<div #chartContainer class="w-full h-full relative">
    <div #tooltip
        class="absolute hidden bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700 rounded-lg pointer-events-none z-50 transition-all duration-200">
    </div>
</div>